/**
 * @author Ariel
 * @date 2020-09-17
 * @desc 活动查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";
import moment from "moment";

let { WizContainer, modelUtils, ossFileUtils } = framework_tool
let { WizCard, WizSpin } = component_tool
let { Session } = utils_tool
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
class ActivityLook extends WizContainer {
  componentName = 'activityLook'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location) {
      if (history.location.pathname === '/interact/activity/activityLook'
        || history.location.pathname === '/featured/management/featuredLook/featuredActivity') {
        if (history.location.record) {
          detailInfo = history.location.record
          Session.set('detailInfo', detailInfo)
        } else {
          detailInfo = Session.get('detailInfo') || {}
        }
      }
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo && this.detailInfo.id) {
      this.doAction({
        path: 'activity/look',
        payload: {
          key: 'activityInfo',
          apiParams: { id: this.detailInfo.id }
        }
      })
    }
  }

  authorityInfo = () => {
    return (
      <WizAuthority value={this.detailInfo && this.detailInfo.authInfo && this.detailInfo.authInfo} mode='Show' showBlock={false} />
    )
  }

  getImgInfo = (image, height, width) => {
    if (image) {
      return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
        <div>
          <img height={height} width={width} src={getOssFilePath(image)} />
        </div>
      </div>
    }
  }

  _render() {
    let { activityInfo } = this.props
    if (activityInfo && activityInfo.success) {
      this.detailInfo = activityInfo.data
    }
    const items = this.detailInfo
    items['state'] == 0 ? items['stateName'] = "关闭" : items['stateName'] = "打开"

    return (
      <React.Fragment>
        <WizCard>
          <WizSpin tip={'加载中'} spinning={this.props.activityLoading}>
            <Descriptions column={1} style={{ paddingLeft: 25 }} bordered={true}>
              <Descriptions.Item label='活动名称'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='活动时间'>{formatterDate(items.startTime)} ~ {formatterDate(items.endTime)}</Descriptions.Item>
              <Descriptions.Item label='主办方'>{items.sponsor}</Descriptions.Item>
              <Descriptions.Item label='活动受众'>{this.authorityInfo()}</Descriptions.Item>
              {/*<Descriptions.Item label='是否需要报名'>{items.applyName}</Descriptions.Item>*/}
              <Descriptions.Item label='简介图片'>{this.getImgInfo(items.remarkImg, 1000, 500)}</Descriptions.Item>
              <Descriptions.Item label='背景图片'>{this.getImgInfo(items.backgroundImg, 450, 500)}</Descriptions.Item>
              <Descriptions.Item label='详情图片'>{this.getImgInfo(items.detailImg, 800, 500)}</Descriptions.Item>
              <Descriptions.Item label='展示图片'>{this.getImgInfo(items.recommendImg, 140, 500)}</Descriptions.Item>
              <Descriptions.Item label='分享图'>{this.getImgInfo(items.shareImg, 310, 600)}</Descriptions.Item>
              <Descriptions.Item label='状态'>{items.stateName}</Descriptions.Item>
            </Descriptions>
          </WizSpin>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activity } = state;
  const activityInfo = modelUtils.getModelEntity(activity, 'activityInfo');
  const load = modelUtils.getLoadingState(state, 'activity')
  return {
    activityInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ActivityLook)

